<template>
    <div class="modal fade reset-vertical" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="thanks-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="far fa-thumbs-up"></i>
                        拍手ありがとうございます！
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label class="badge badge-pill badge-info">{{applause.caption}}</label>
                    が押されました。
                    更に感想を送ることができます。
                    <div class="small">
                        拍手だけでも構いません。
                    </div>

                    <div class="form-group my-4">
                        <div class="row">
                            <div class="col-sm-6">
                                <h6>感想</h6>
                            </div>
                            <div class="col-sm-6 text-right text-muted small">
                                <span :class="{'text-danger': review.body.length > 1000}">( {{$filters.numberFormat(review.body.length )}} / 1,000文字 )</span>
                            </div>
                        </div>
                        <div class="text-pane">
                            <div class="text-pane-dummy">{{review.body + '\u200b'}}</div>
                            <textarea class="text-pane-editor"
                                v-model="review.body"
                                @click.stop=""
                                placeholder="面白かった点、好きな点、感動した点など"></textarea>
                        </div>
                        <div class="recaptcha-notice">
                            <img src="https://www.gstatic.com/recaptcha/api2/logo_48.png" class="float-left mr-2" />
                            <div>
                                This site is protected by reCAPTCHA and the Google
                                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                            </div>
                        </div>
                    </div>

                    <div class="small">
                        <h6>感想は直接作者へ送られます</h6>
                        <p>
                            あなたの感想は直接作者に送られます。
                            作者が目にする前に他の読者に読まれることはありません。
                            作者が感想を見た後で、返信と共に感想が公開されることがあります。
                        </p>
                        <h6>不適切な書き込みはご遠慮ください</h6>
                        <ul>
                            <li>作者や作品への誹謗中傷</li>
                            <li>作品と無関係な投稿</li>
                            <li>宣伝、勧誘など感想と無関係な内容</li>
                            <li>自分の作品への感想の要求</li>
                            <li>誤字、脱字、整合性ミス等の指摘</li>
                        </ul>
                        利用規約やガイドラインに違反する投稿は削除の対象となります。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" :disabled="disabled" @click="save()">送信</button>
                </div>
                <div class="modal-body" v-if="reviews.length">
                    <div class="text-center">
                        送信済みの感想
                    </div>
                    <div class="review" v-for="r in reviews" :key="r.id">
                        <div v-if="r.applause">
                            <span class="badge badge-info">
                                {{r.applause.caption}}
                            </span>
                        </div>
                        <div class="review-body small" v-html="$filters.wrap(r.body)"></div>
                        <div class="review-reply small" v-if="r.reply" v-html="$filters.wrap(r.reply)"></div>
                        <div class="text-right small">
                            <div v-if="r.section" v-html="$filters.ruby(r.section.section_name)"></div>
                            {{$filters.dateFormat(r.updated_at)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.recaptcha-notice {
    font-size: .8rem;
    margin: .5rem 0;
    padding: .5rem 1rem;
    border-radius: .5rem;
}
.buttons {
    margin: .7rem 0;
    padding: .5rem;
}
.review {
    padding: 1rem;
    margin-bottom: .5rem;
    border-radius: .5rem;
    .review-reply {
        margin: 1rem .5rem .5rem;
        padding: 1rem .5rem .5rem;
        border-top: 1px solid #ccc;
    }
}

.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        font-size: 1rem;
        line-height: 2rem;
        box-sizing: border-box;
        padding: .5rem 1rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: .5rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>

<script>
export default {
    props: {
        applause: {
            required: true
        },
        section_id: {
            required: true,
        }
    },
    data() {
        return {
            review: {
                body: "",
                book_id: null,
                applause_id: null,
                section_id: null,
                token: null,
            },
            reviews: [],
        }
    },
    methods: {
        load() {
            grecaptcha.ready(() => {
                grecaptcha.execute(this.$store.state.recaptcha_site_key, {action: 'homepage'})
                    .then((token) => {
                        this.review.token = token
                    });
            });
            axios.get("/author/reviews/get", {params: {book_id: this.applause.book_id}}).then(res => {
                this.reviews = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            if (!this.review.body || !this.review.token) return;
            this.review.book_id = this.applause.book_id;
            this.review.applause_id = this.applause.id;
            this.review.section_id = this.section_id;
            axios.post("/author/review", this.review).then(res => {
                alert.msg("感想を送信しました。ありがとうございます！");
                this.$emit("saved");
                this.review.body = "";
                $("#thanks-modal").modal("hide");
            }).catch(err => {
                alert.err(err.response);
            });
        },
    },
    computed: {
        disabled() {
            return !this.review.body || !this.review.token;
        }
    },
    mounted() {
        $("#thanks-modal").on("show.bs.modal", (e) => {
            this.load();
        });
    },
}
</script>